'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Static = undefined;

var _Static2 = require('./Static');

var _Static3 = _interopRequireDefault(_Static2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Static = _Static3.default;


//////////////////
// WEBPACK FOOTER
// ./src/containers/Static/index.js
// module id = 1852
// module chunks = 0